<div
  *ngIf="data"
  class="vi-toast flex gt-xs:flex-row xs:flex-col gap-[10px] xs:justify-start xs:items-stretch gt-xs:justify-between gt-xs:items-center"
>
  <div
    [attr.data-at-message-type]="data.type"
    class="message flex flex-row justify-between items-center sm:flex-[100%] sm:max-w-[100%]"
    [class.full-width]="!data.actions"
  >
    <div>
      <mat-icon *ngIf="data.icon">{{ data.icon }}</mat-icon>
      {{ data.message }}
    </div>
    <button *ngIf="!data.actions" mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div
    *ngIf="data.actions"
    class="actions flex flex-row gap-[5px] justify-end items-center xs:justify-evenly sm:flex-[100%] sm:max-w-[100%]"
  >
    <ng-container *ngFor="let action of data.actions">
      <ng-container *ngIf="data.type === 'info'">
        <button
          *ngIf="action.raised"
          [id]="action.id"
          mat-raised-button
          color="accent"
          (click)="onAction(action)"
        >
          {{ action.name }}
        </button>
        <button
          *ngIf="!action.raised"
          [id]="action.id"
          mat-button
          color="accent"
          (click)="onAction(action)"
        >
          {{ action.name }}
        </button>
      </ng-container>
      <ng-container *ngIf="data.type === 'success' || data.type === 'error'">
        <button
          *ngIf="action.raised"
          [id]="action.id"
          mat-raised-button
          color="accent"
          (click)="onAction(action)"
        >
          {{ action.name }}
        </button>
        <button
          *ngIf="!action.raised"
          [id]="action.id"
          mat-button
          color="accent"
          (click)="onAction(action)"
        >
          {{ action.name }}
        </button>
      </ng-container>
      <ng-container *ngIf="data.type === 'warning'">
        <button
          *ngIf="action.raised"
          [id]="action.id"
          mat-raised-button
          color="accent"
          (click)="onAction(action)"
        >
          {{ action.name }}
        </button>
        <button
          *ngIf="!action.raised"
          [id]="action.id"
          mat-button
          color="warn"
          (click)="onAction(action)"
        >
          {{ action.name }}
        </button>
      </ng-container>
    </ng-container>
  </div>
</div>
